import { BaseService } from './base.service';
import {
  ITicketListingViewModel,
  TicketListingViewModel,
  ITicketChannel,
  ITicket,
  ITicketParameter,
  TicketDto,
  ITicketInterventionReport
} from '../models/ticket';
import { Uris } from '../common/constants';
import { IBaseListingModel } from '../models/base-listing.model';
import { BaseModel } from '../models/base.model';
import { TicketCharacters, StateTypes, TicketTypes } from '../common/enums';
import { isNullOrUndefined } from 'util';
import moment = require('moment');
import * as JSONPatch from "fast-json-patch";

import { IApartmentListingViewModel } from '../models/apartment';
export interface ITicketService {
  getTickets(param: any): Promise<any>
  getTicket(id: number): Promise<ITicket>
  getTicketChannelById(channelId: number, ticketId: number): Promise<ITicketChannel>;
  recordTicket(ticket: ITicket, agencyId: number, attachments: any[]): Promise<ITicket>;
  recordChannel(ticketId: number, name: string, participants: number[]): Promise<ITicket>;
  recordAskAppointment(ticketId: number, startDate: any): Promise<any>;
  sendMessage(ticketId: any, channelId: any, message: string, createdAt: string): Promise<any>;
  updateMessage(ticketId: any, channelId: any, messageId: any, data: any): Promise<any>;
  updateAttachment(ticketId: any, channelId: any, attachmentId: any, data: any): Promise<any>;
  sendFile(payload: { ticketId: string, channelId: string, creator: string, data: any }, config): Promise<any>;
  actionRequestMandateOrQuote(ticketId: string, fkActors: number[], attachments: any[], keyText: string, textValue: string): Promise<any>;
  initTicket(): ITicket;
  requestToJoin(ticketId: string, userId: string, channelId: string): Promise<any>;
  requestToJoinChannel(ticketId: string, channelId: string): Promise<any>;
  getCharacterProblems(): Promise<any>;
  getEquipments(params): Promise<any>;
  getTicketClosureReason(): Promise<any>;
  getTicketReason(): Promise<any>;
  getTicketAppointments(ticketId: string): Promise<IApartmentListingViewModel>;

  addParticipants(option: { ticketId: string, channelId: string, data: any[] }): Promise<any>;
  removeParticipants(option: { ticketId: string, channelId: string, data: any[] }): Promise<any>;
  sendInterventionReport(ticketId: string, intervetionReport: ITicketInterventionReport): Promise<any>;
  getTicketPriorityLevels(): Promise<any>;
  getTicketSubstatus(): Promise<any>;
  getTicketProblemType(): Promise<any>;
}
export class TicketService extends BaseService {
  ticketParameter: ITicketParameter;
  /**
   *
   */
  /**
   *
   */
  constructor() {
    super('ticket');
  }
  public initTicket(): ITicket {
    return new TicketDto({
      fk_ticket_character_problem: null,
      origin_demand: 'call',
      pb_type: 'public',
      mandates: [],
      quotes: [],
      //creator: null,
      declarant: null,
      managers: [],
      owners: [],
      participants: [],
      managers_assigned: [],
      apartments: []
    })
  }
  /** Get list of ticket
   * @param:param | Ticker filters
   * @param allowPagination if allowPagination is true, return origin data from api, else return list tickets only
   */
  public async getTickets(param: ITicketParameter, allowPagination?: boolean) {

    /**Avoid hashtag on url */
    let cookedParameter = JSON.parse(JSON.stringify(param));


    if (!this.ticketParameter) {
      this.ticketParameter = cookedParameter;
    } else {
      const changes = JSONPatch.compare(this.ticketParameter, cookedParameter);
      const orderChanges = changes.find(x => x.path.indexOf('order') > -1)
      if (orderChanges) {
        const paths: string[] = orderChanges.path.split('/')
        const index: number = Number(paths[paths.length - 1]);
        this.ticketParameter = cookedParameter;
        cookedParameter = {
          ...cookedParameter,
          orderKeys: [cookedParameter.orderKeys[index]],
          orderValues: [cookedParameter.orderValues[index]]
        }
      }
    }

    if (cookedParameter.block)
      cookedParameter.block = cookedParameter.block.join(',')

    if (cookedParameter.key) {

      if (param.key && param.key.length > 0) {
        cookedParameter.key = param.key.replace('#', '')
      }
    }

    return await super.get<ITicketListingViewModel[], IBaseListingModel>(Uris.Ticket, cookedParameter)
      // @ts-ignore
      .then((rawTickets: IBaseListingModel) => {
        if (allowPagination) {
          return Promise.resolve(rawTickets);
        }
        return Promise.resolve(rawTickets.data);
      })
      .catch(error => Promise.reject(error))
  }
  public getTicket(id: number | string) {
    return super.get(Uris.TicketDetail.replace(':id', id.toString()))
      .then((ticket: ITicket) => ticket)
      .catch(error => Promise.reject(error))
  }
  /** Get channel by ticket id and channel id */
  public getTicketChannelById(channelId: number, ticketId: number): Promise<ITicketChannel> {
    return this.get(
      Uris.TicketChanel
        .replace(':id', ticketId.toString())
        .replace(':cid', channelId.toString())
    )
      .then((ticket: ITicketChannel) => {
        return Promise.resolve(ticket as ITicketChannel);
      })
      .catch(error => Promise.reject(error))
  }

  /** Handle recording ticket with 2 cases: In case ticket has no id, it means this ticket is a new one. Call api create, unless call api upate */
  public async recordTicket(ticket: ITicket, agencyId: number ): Promise<any> {
    return this.cookTicket(ticket)
      .then((cookedTicket => {

        //@ts-ignore
        /*if (typeof cookedTicket.tenants === "number") {
          cookedTicket.tenants = [cookedTicket.tenants]
        }*/

        /**
         * DRIV-1036: Louis Remove fk_ticket_apartment if pbtype is public
         * Apply on ly beta. not for all
         */
        /*if (cookedTicket.pb_type === TicketTypes.Public) {
          delete cookedTicket.fk_ticket_apartment;
          delete cookedTicket.apartments;
        }*/

        delete cookedTicket.tenants
        delete cookedTicket.owners
        delete cookedTicket.managers
        delete cookedTicket.caretakers

        return super.post(Uris.Ticket, { ...cookedTicket, fk_ticket_agency: agencyId })
          .then(createdTicket => {
            return Promise.resolve(createdTicket);
          })
          .catch(error => Promise.reject(error));
      }))
  }

  public async updateTicket(payload: any) : Promise<any> {
    const { id, ...rest } = payload
    return super.patch(Uris.TicketDetail.replace(':id',id),{...rest})
        .then( updatedTicket => {
          return Promise.resolve(updatedTicket)
        })
        .catch(err=> Promise.reject(err) )
  }

  public async recordChannel(ticketId: number, name: string, participants: any[]) {
    return super.post(Uris.Channel, {
      fk_channel_ticket: ticketId,
      name,
      participants: participants.map(x => x.id)
    })
      .then(response => response)
      .catch(error => error);
  }
  public async sendMessage(ticketId: any, channelId: any, message: string, createdAt: string) {
    return super.post(Uris.TicketSendMessage.replace(':id', ticketId).replace(':cid', channelId), { message, createdAt })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  }
  public async updateMessage(ticketId: any, channelId: any, messageId: any, data: any) {
    return super.patch(Uris.TicketUpdateMessage.replace(':id', ticketId).replace(':cid', channelId).replace(':mid', messageId), data)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  }
  public async updateAttachment(ticketId: any, channelId: any, attachmentId: any, data: any) {
    return super.patch(Uris.TicketUpdateAttachment.replace(':id', ticketId).replace(':cid', channelId).replace(':aid', attachmentId), data)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  }
  public async sendFile({ ticketId, channelId, creator, data }, target?) {
    type payloadFile = {
      sharing_type?:any,
      creator:any,
      loader_id:any,
      files: any,
    }
    let payload:payloadFile = {
      creator,
      loader_id: data.loader_id,
      files: [{
        type: data.type === 'file' ? 'video' : data.type,
        name: data.name, file: data.file
      }]
    }
    if(data.hasOwnProperty('attributes') &&
      data.hasOwnProperty('reference') &&
      data.hasOwnProperty('fk_attachment_type') &&
      data.hasOwnProperty('fk_attachment_type_level_2'))
    {
      payload.sharing_type=[]
      payload.files[0].fk_attachment_type = data.fk_attachment_type
      payload.files[0].fk_attachment_type_level_2 = data.fk_attachment_type_level_2
      payload.files[0].reference = data.reference
      payload.files[0].attributes = data.attributes
    }
    return super.post(Uris.TicketSendAttachment.replace(':id', ticketId).replace(':cid', channelId),
      payload, {
        onUploadProgress: (progressEvent) => this.onUploadProgress(progressEvent, data)
      })
      .then(response => response)
      .catch(error => {
        return Promise.reject(error)
      })
  }

  public async actionSendDocument(ticketId: string, channelId: string, attachments: any[]) {

  }
  public async actionRequestMandateOrQuote(ticketId: string, fkActors: number[], attachments: any[], keyText: string, textValue: string) {
    const link: string = keyText === 'quote_request_text' ? 'TicketActionRequestQuote' : 'TicketActionRequestMandate';
    return fkActors.map(fk_actor_entity =>
      super.post(Uris[link].replace(':id', ticketId), {
        fk_actor_entity,
        attachments: attachments,
        [keyText]: textValue
      })
        .then(response => {
          return response
        })
        .catch(error => error))
  }
  public async actionCloseTicket(ticketId: string, closureReason: any) {
    return super.post(Uris.TicketActionClose.replace(':id', ticketId), { ...closureReason, force: true })
      .then(response => response)
      .catch(error => error)
  }
  public async actionReopenTicket(ticketId: string) {
    return super.post(Uris.TicketActionReopen.replace(':id', ticketId))
      .then(response => response)
      .catch(error => error)
  }
  /** Cook ticket's data before send to api. Remove all properties have no data, only keep mandantary fields */
  public cookTicket(ticket: ITicket) {

    const clearedTicket: ITicket = JSON.parse(JSON.stringify(ticket)); /** Clone ticket to a new one to avoid effecting directly on modal */

    /*if (isNullOrUndefined(clearedTicket.tenants)) {
      clearedTicket.tenants = [];
    } else if (!isNullOrUndefined(clearedTicket.tenants) && typeof clearedTicket.tenants === 'object') {
      clearedTicket.tenants = [(clearedTicket.tenants as any).id]
    } else if (clearedTicket.tenants === 'string' || clearedTicket.tenants === 'number') {
      clearedTicket.tenants = [clearedTicket.tenants]
    }*/
    if (Array.isArray(clearedTicket.participants)) {
      clearedTicket.participants = clearedTicket.participants.map(x => {
        if ((typeof x === "number"))
          return x
        else if (!isNullOrUndefined(x) && typeof x === 'object')
          return (x as any).id
      })
    }

    //this.mapToBaseModel(clearedTicket, 'creators');
    this.mapToBaseModel(clearedTicket, 'declarant');
    //this.mapToBaseModel(clearedTicket, 'managers');
    //this.mapToBaseModel(clearedTicket, 'caretakers');
    //this.mapToBaseModel(clearedTicket, 'owners');
    this.mapToBaseModel(clearedTicket, 'mandates');
    this.mapToBaseModel(clearedTicket, 'quotes');
    //this.mapToBaseModel(clearedTicket, 'tenants');
    this.mapToBaseModel(clearedTicket, 'managers_assigned');
    this.mapToBaseModel(clearedTicket, 'participants');

    return Promise.resolve(clearedTicket)
  }
  public getTicketClosureReason() {
    return super.get(Uris.Closure)
  }
  public getTicketReason() {
    return super.get(Uris.TicketReason)
  }
  recordAskAppointment(ticketId: number, startDate: string): Promise<any> {
    const data: { action_type: string, start_date: string } = {
      action_type: StateTypes.AppoinmentAsk,
      start_date: `${moment(new Date(startDate)).format('YYYY-MM-DDTHH:mm:ss')}.000Z`
    };
    return super.post(Uris.TicketAskAppointment.replace(':id', ticketId.toString()), data)
      .then(response => response)
      .catch(error => error)
  }
  requestToJoin(ticketId: string, userId: string, channelId: string) {

    const user_id: number = parseInt(userId);
    const channel: number = parseInt(channelId);

    if (user_id > 0 && channel > 0) {
      return super.post(
        Uris.TicketJoin.replace(':id', ticketId),
        { channel: channel, user_id: userId }
      )
        .then(response => response)
        .catch(error => error);
    }
    else {
      return Promise.reject(`User ID: ${userId} or Channel ID: ${channelId} is invalid`)
    }
  }

  requestToJoinChannel(ticketId: string, channelId: string) {

    return super.post(Uris.TicketJoinChannel.replace(':id', ticketId).replace(':cid', channelId))
      .then(response => response)
      .catch(error => error);
  }

  getCharacterProblems() {
    return super.get('/agency_character_problem')
  }
  getEquipments(params) {
    return super.get('/equipment', params)
  }
  getTicketPriorityLevels() {
    return super.get(Uris.TicketPriority)
  }
  getTicketSubstatus() {
    return super.get(Uris.TicketSubstatus)
  }
  getTicketProblemType() {
    return super.get(Uris.TicketProblemType)
  }
  /** Cooker method */
  private mapToBaseModel(obj: ITicket, key: string) {
    if (obj[key] == null) return;
    if (obj[key].length === 0) {
      delete obj[key];
      return;
    }
    return;
  }

  /** Map raw object comes from api to view model */
  public *mapTicketListingModelToTicketListingViewModel(ticket: ITicketListingViewModel) {
    yield new TicketListingViewModel(ticket)
  }

  public async addParticipants({ ticketId, channelId, data }) {
    if (isNaN(Number(ticketId)) || isNaN(Number(channelId))) {
      return Promise.reject("L'identifiant du ticket ou de la chaîne n'est pas valide")
    };

    const ids: number[] = data.map(x => x.id);

    return await super.post(Uris.TicketAddParticipants.replace(':id', ticketId).replace(':cid', channelId), {
      action: "add",
      user_ids: ids
    })
  }

  public async removeParticipants({ ticketId, channelId, data }) {

    if (isNaN(Number(ticketId)) || isNaN(Number(channelId))) {
      return Promise.reject("L'identifiant du ticket ou de la chaîne n'est pas valide")
    };


    const ids: number[] = data.map(x => x.id)
    return await super.post(Uris.TicketRemoveParticipants.replace(':id', ticketId).replace(':cid', channelId), {
      action: "remove",
      user_ids: ids
    })
  }

  public async getTicketAppointments(ticketId: string) {
    return await super.get(Uris.TicketGetAppointments.replace(':id', ticketId))
      .then(res => {
        console.log(res, 'appoinemtns');

        return res;
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  public async sendInterventionReport(ticketId: string, interventionReport: ITicketInterventionReport) {
    const startDate: string = moment(interventionReport.start_date).format("YYYY-MM-DDTHH:mm");
    const endDate: string = moment(interventionReport.end_date).format("YYYY-MM-DDTHH:mm");

    if(interventionReport.fk_appointment === null) delete interventionReport.fk_appointment

    return await super.post(Uris.TicketInterventionReport.replace(':id', ticketId), {
      ...interventionReport,
      start_date: `${startDate}:00.000Z`,
      end_date: `${endDate}:00.000Z`,
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ticket.service.ts